import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  ownerLabel: '',
  ownerValue: {},
  searchProjectQuery: '',
  isFirstAttempt: true,
}
export const supplierResearchAgent = createSlice({
  name: 'supplierResearchAgent',
  initialState,
  reducers: {
    setSelectedOwnerLabel: (state, action) => {
      state.ownerLabel = action?.payload
    },
    setSelectedOwnerValue: (state, action) => {
      state.ownerValue = action?.payload
    },
    setSearchProjectQuery: (state, action) => {
      state.searchProjectQuery = action.payload
    },
    setIsFirstAttempt: (state, action) => {
      state.isFirstAttempt = action.payload
    },
    setQuery: (state, action) => {
      state.searchProjectQuery = action.payload.searchText
      state.ownerValue = action.payload.ownerValue
      state.ownerLabel = action.payload.ownerLabel
    },
    clearState: () => initialState,
  },
})

export const {
  setSelectedOwnerLabel,
  setSelectedOwnerValue,
  clearState,
  setSearchProjectQuery,
  setIsFirstAttempt,
  setQuery,
} = supplierResearchAgent.actions
export default supplierResearchAgent.reducer
